var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.6V10.4C15 11.28 14.325 12 13.5 12H11.4375C11.4375 11.68 11.175 11.4 10.875 11.4C10.575 11.4 10.3125 11.68 10.3125 12H1.5C0.675 12 0 11.28 0 10.4L0 7.6C0.825 7.6 1.5 6.88 1.5 6C1.5 5.12 0.825 4.4 0 4.4L0 1.6C0 0.72 0.675 0 1.5 0H10.3125C10.3125 0.32 10.575 0.599999 10.875 0.599999C11.175 0.599999 11.4375 0.32 11.4375 0H13.5C14.325 0 15 0.72 15 1.6V4.4C14.175 4.4 13.5 5.12 13.5 6C13.5 6.88 14.175 7.6 15 7.6ZM10.875 1.4C10.575 1.4 10.3125 1.68 10.3125 2C10.3125 2.32 10.575 2.6 10.875 2.6C11.175 2.6 11.4375 2.32 11.4375 2C11.4375 1.68 11.175 1.4 10.875 1.4ZM10.875 3.4C10.575 3.4 10.3125 3.68 10.3125 4C10.3125 4.32 10.575 4.6 10.875 4.6C11.175 4.6 11.4375 4.32 11.4375 4C11.4375 3.68 11.175 3.4 10.875 3.4ZM10.875 5.4C10.575 5.4 10.3125 5.68 10.3125 6C10.3125 6.32 10.575 6.6 10.875 6.6C11.175 6.6 11.4375 6.32 11.4375 6C11.4375 5.68 11.175 5.4 10.875 5.4ZM10.875 7.4C10.575 7.4 10.3125 7.68 10.3125 8C10.3125 8.32 10.575 8.6 10.875 8.6C11.175 8.6 11.4375 8.32 11.4375 8C11.4375 7.68 11.175 7.4 10.875 7.4ZM10.875 9.4C10.575 9.4 10.3125 9.68 10.3125 10C10.3125 10.32 10.575 10.6 10.875 10.6C11.175 10.6 11.4375 10.32 11.4375 10C11.4375 9.68 11.175 9.4 10.875 9.4Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicTag);
export default __webpack_public_path__ + "static/media/tic_tag.d7f3a8a49882d089b2ae22697e3887ec.svg";
export { ForwardRef as ReactComponent };